export const ONE_MILE_IN_METER = 1609.344;

export const MILES_TO_METERS = (miles) => miles * ONE_MILE_IN_METER;
